import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import noop from "../../../services/noop";
import QuestionPreview from "../QuestionPreview";
import useStyles from "./styles";

const AnswerScale = (props) => {
  const styles = useStyles(props);

  const [selected, setSelected] = useState(props.value);

  const handleChange = (num) => {
    setSelected(num);
    props.handleChange(num);
  };

  useEffect(() => {
    if (props.value) {
      setSelected(props.value);
    } else {
      setSelected(null);
    }
  }, [props.value]);

  return (
    <div className={styles.questionWrapper}>
      <fieldset aria-required={props.required}>
        <legend>
          <QuestionPreview
            question={props.question}
            required={props.required}
            helperText={props.helperText}
          />
          <p
            className={styles.offscreenText}
          >{`One being ${props.endpointLow} and ${props.choices.length} being ${props.endpointHigh}`}</p>
        </legend>
        <div
          className={`${
            props.choices.length > 5
              ? styles.scaleWrapper
              : styles.scaleWrapperSmall
          }`}
        >
          <div
            className={`${
              props.choices.length > 5
                ? styles.scaleContainer
                : styles.scaleContainerSmall
            }`}
            role="radiogroup"
          >
            {props.choices.map(({ value }) => (
              <>
                <label
                  className={styles.rangeCircle}
                  key={value}
                  isselected={value == selected ? "true" : "false"}
                >
                  <input
                    className={styles.radioBtn}
                    type="radio"
                    id={`${value}-${props.question.replace(/\s+/g, "")}`}
                    name={`${props.question.replace(/\s+/g, "")}`}
                    onClick={() => handleChange(value)}
                    aria-describedby={props.questionId + "-error"}
                  />
                  <span>{value}</span>
                </label>
              </>
            ))}
          </div>
          <div
            className={`${
              props.choices.length > 5
                ? styles.endpointIndicatorContainer
                : styles.endpointIndicatorContainerSmall
            }`}
          >
            <div className={styles.endpointIndicator}>{props.endpointLow}</div>
            <div className={styles.endpointIndicator}>{props.endpointHigh}</div>
          </div>
        </div>
      </fieldset>
    </div>
  );
};

AnswerScale.propTypes = {
  question: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
  choices: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)).isRequired,
  handleChange: PropTypes.func,
};

AnswerScale.defaultProps = {
  handleChange: noop,
  required: false,
  choices: [],
};

export default AnswerScale;
